import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "Scroll Up Button",
  type: "rh/components/content/scrollbutton",
  isContainer: true,
  config: {
    emptyLabel: "Scroll Up Button",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
